"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _SiteFill = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/SiteFill"));

// Generated by script, don't edit it please.
var SiteFill = (0, _createSvgIcon["default"])({
  as: _SiteFill["default"],
  ariaLabel: 'site fill',
  category: 'layout',
  displayName: 'SiteFill'
});
var _default = SiteFill;
exports["default"] = _default;
module.exports = exports.default;